import React, { createContext, useEffect, useState } from 'react';
import { Table } from 'reactstrap';
import styled from '@emotion/styled';

import { useFormContext } from 'react-hook-form';

import InputTypes from 'components/InputRadioButton/inputRadioButton';

export const StateHandle = createContext(null);

const SurveyScaling = ({ defaultValues, ...props }) => {
  const { watch } = useFormContext();
  const [scaling, setScaling] = useState(defaultValues);

  const TD = styled.td`
    & {
      cursor: default;
      border: 8px solid white !important;
      border-right: 0px !important;
      border-left: 0px !important;
    }
  `;
  const TableContainer = styled.div`
    overflow-x: auto;
    & > table {
      pointer-events: ${props?.isDisable ? 'none' : 'auto'};
      border-collapse: collapse;
      width: 100%;
    }
    th {
      background-color: white !important;
    }
    & > table > tbody > tr:nth-child(even) {
      background-color: #efefef;
    }
    & > table > tbody > tr:nth-child(odd) {
      background-color: #f9f9f9;
    }
  `;
  const watchValue = watch(['scalePoints']);

  return (
    <TableContainer>
      <Table borderless>
        <thead>
          <tr>
            <th></th>
            {defaultValues?.scalePoints?.map((thead, index) => (
              <th key={index}>
                <div className="d-flex justify-content-center align-items-center">
                  {thead?.scale}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {scaling?.options?.map((opt, index) => (
            <tr key={index}>
              <TD>{opt?.question}</TD>
              {opt?.value?.map((val, valIndex, currentArray) => (
                <TD key={valIndex}>
                  <div
                    className={`w-100 h-100 ml-0 d-flex justify-content-center align-items-center `}
                  >
                    <StateHandle.Provider
                      value={{
                        item: {
                          value: opt?.question,
                          index: valIndex,
                          questionIndex: index,
                          checked: val,
                          currentArray,
                        },
                        type: scaling?.inputType,
                        setScaling,
                        isMulti: scaling?.isMulti,
                        scaling,
                        ...props,
                      }}
                    >
                      <InputTypes
                        name={
                          scaling?.isMulti
                            ? `feedBack${valIndex}${index}`
                            : `feedBack${index}`
                        }
                      />
                    </StateHandle.Provider>
                  </div>
                </TD>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
};

export default SurveyScaling;
